import { api } from '../api';
import type { CacheStatusEntry } from '../../types/api';

export const CacheAPI = {
  status: () => api.get<CacheStatusEntry[]>('/api/admin/cache/status'),
  clear: (key: string, reason: string, collectionName?: string, deleteMessages?: boolean) =>
    api.post<{ clearedAt: string }>(`/api/admin/cache/${encodeURIComponent(key)}/clear`,
      { reason, collectionName, deleteMessages }, { idempotent: true }),
};
